import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';

interface ConfirmationDialogProps {
  title: string;
  query: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmationDialog = (props: ConfirmationDialogProps) => {
  const { title, query, isOpen, onClose, onConfirm } = props;

  return (
    <Dialog
      maxWidth="xs"
      open={isOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {query}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onClose} color="primary">
          Annuleren
        </Button>
        <Button onClick={onConfirm} color="secondary">
          Verwijderen
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
